export default "__VITE_ASSET__RiYPjTkj__"